export default __webpack_public_path__ + "images/JQ.24f14d5.png";